module Hereabout.Navigator.Geolocation
  ( Coordinates(..)
  , GeolocationError(..)
  , Position(..)
  , PositionMissing(..)
  , accuracy
  , getCurrentPosition
  , watchCurrentPosition
  )
  where

import Prelude

import Data.JSDate (JSDate, toDateTime)
import Data.DateTime (DateTime)
import Data.Maybe (fromJust)
import Effect (Effect)
import Effect.Aff (Aff)
import Effect.Aff.Compat (EffectFnAff, fromEffectFnAff)
--import Hereabout.Data.Georef (class Georef, class GeorefWithAccuracy)
import Partial.Unsafe (unsafePartial)

type Coordinates = 
  { latitude         :: Number
  , longitude        :: Number
  , accuracy         :: Number
  }

type InternalPosition = 
  { coords    :: Coordinates
  , timestamp :: Int
  }

newtype Position = Position 
  { coords    :: Coordinates
  , timestamp :: Int
  }

derive instance eqPosition :: Eq Position
derive instance ordPosition :: Ord Position

data GeolocationError
  = GeolocationPermissionDenied
  | GeolocationPositionUnavailable
  | GeolocationTimeout

instance showGeolocationError :: Show GeolocationError where
  show GeolocationPermissionDenied = "Geolocation error: GPS Permission Denied."
  show GeolocationPositionUnavailable = "Geolocation error: GPS position unavailable."
  show GeolocationTimeout = "Geolocation error: GPS timed out."

data PositionMissing
  = AwaitingPosition
  | ErrorAcquiringPosition GeolocationError

codeToGeolocationError :: Partial => Int -> GeolocationError
codeToGeolocationError 1 = GeolocationPermissionDenied
codeToGeolocationError 2 = GeolocationPositionUnavailable
codeToGeolocationError 3 = GeolocationTimeout

instance positionShow :: Show Position where 
  show (Position pos) =
    "(latitude : " <> (show $ pos.coords.latitude) <> " longitude : " <> (show $ pos.coords.longitude) <> ")"


getCurrentPosition :: Aff Position
getCurrentPosition = map Position $ fromEffectFnAff $ _getCurrentPosition unit

watchCurrentPosition :: (Position -> Effect Unit) -> (GeolocationError -> Effect Unit) -> Effect Unit
watchCurrentPosition f fe = _watchCurrentPosition (f <<< Position) (fe <<< unsafePartial codeToGeolocationError)


accuracy ∷ Position → Number
accuracy (Position pos) = pos.coords.accuracy

foreign import _getCurrentPosition :: Unit -> EffectFnAff InternalPosition
foreign import _watchCurrentPosition :: (InternalPosition -> Effect Unit) -> (Int -> Effect Unit) -> Effect Unit

